import {
  Avatar, Box, ButtonBase, Typography,
} from '@mui/material';
import { IconMenu2 } from '@tabler/icons';
import { makeStyles } from 'tss-react/mui';

import LogoSection from '../LogoSection';

import ProfileSection from './ProfileSection';

const env = process.env.REACT_APP_ENV;

const envTitle = env === 'qa' ? 'QA' : 'Stage';

const useStyles = makeStyles()((theme) => ({
  grow: {
    flexGrow: 1
  },
  headerAvatar: {
    ...theme.typography.commonAvatar,
    ...theme.typography.mediumAvatar,
    transition: 'all .2s ease-in-out',
    background:
      theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.secondary.light,
    color:
      theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
    '&:hover': {
      background:
        theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
      color:
        theme.palette.mode === 'dark'
          ? theme.palette.secondary.light
          : theme.palette.secondary.light
    }
  },
  boxContainer: {
    width: '228px',
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      width: 'auto'
    }
  }
}));

const Header = ({ handleLeftDrawerToggle }) => {
  const { classes } = useStyles();

  return (
    <>
      <div className={classes.boxContainer}>
        <Box
          component="span"
          sx={{
            position: { xs: 'absolute', md: 'relative' },
            left: { xs: '50%', md: 'auto' },
            top: { xs: '50%', md: 'auto' },
            transform: { xs: 'translate(-50%, -50%)', md: 'none' },
            flexGrow: 1
          }}>
          <LogoSection />
        </Box>

        <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
          <Avatar
            variant="rounded"
            className={classes.headerAvatar}
            onClick={handleLeftDrawerToggle}
            color="inherit">
            <IconMenu2 stroke={1.5} size="1.3rem" />
          </Avatar>
        </ButtonBase>
      </div>

      <div className={classes.grow} />
      {env !== 'prod' && (
        <Typography
          zIndex={1}
          variant="h2"
          mr={2}
          color="red"
          sx={{ fontSize: { xs: '16px', sm: '24px' } }}
        >
          {envTitle}
          {' '}
          Environment
        </Typography>
      )}
      <ProfileSection />
    </>
  );
};

export default Header;
